import request from './request';

export const fetchJournalists = () =>
  request({
    method: 'GET',
    url: '/api/v1/journalists/?no_page&journal__division=1',
    protectedRoute: true,
    newApi: false
  });
